import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Grid, TextField, Typography } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Button from "@mui/material/Button";
import React, { useState } from "react";
import HmPageHeaderTitle from "../../unit/HmPageHeaderTitle";
// import Container from "@mui/material/Container";
import HeaderLabelTitle from "../../unit/HeaderLabelTitle";
// import HeaderLabelValue from "../../unit/HeaderLabelValue";
import Checkbox from "@mui/material/Checkbox";
import { styled } from "@mui/material/styles";
import { useEffect } from "react";
import { useGetOne } from "react-admin";
import { Controller, useForm } from "react-hook-form";
import sendRequest from "../../dataProvider/sendRequest";
import CustomMessage from "../../unit/CustomMessage";
import DisabledButtonWithTip from "../../unit/DisabledButtonWithTip";
import HeaderTableLabelTitle from "../../unit/HeaderTableLabelTitle";
import HeaderTableLabelValue from "../../unit/HeaderTableLabelValue";
import formatCurrency from "../../unit/formatCurrency";
import formatPercentage from "../../unit/formatPercentage";
import useNotify from "../../unit/useNotify";
import FinancialConditionCashFlow from "./FinancialConditionCashFlow";
const MainSection = styled("article")({
  //   paddingTop: '64px', // 头部高度
  paddingTop: "10px",
  // paddingBottom: "48px", // 底部高度
  height: `calc(100vh - 120px - 60px - 110px - 55px)`, // 视口高度减去头部和底部的高度
  overflowY: "auto", // 可滚动
  backgroundColor: "#fff",
});
const CustomSmallTextField = styled(TextField)({
  width: "100px",
  "& .MuiInputBase-root": {
    width: "100px",
    "&.Mui-disabled": {
      background: "#e5e5e594",
    },
  },
  "& .MuiOutlinedInput-root": {
    width: "100px",
    "&.Mui-disabled": {
      background: "#e5e5e594",
    },
  },
});

const label = { inputProps: { "aria-label": "Checkbox demo" } };

const formatCurrencyInputValue = (value: any) => {
  if (value === "" || value == null) {
    return "";
  }

  const sanitizedValue = String(value).replace(/[^0-9.-]+/g, "");

  if (
    sanitizedValue === "" ||
    sanitizedValue === "-" ||
    sanitizedValue === "." ||
    sanitizedValue === "-."
  ) {
    return "";
  }

  const numericValue = Number(sanitizedValue);

  if (!Number.isFinite(numericValue)) {
    return "";
  }

  return formatCurrency(numericValue);
};

const sanitizeCurrencySubmitValue = (value: any) => {
  if (value === "" || value == null) {
    return "";
  }

  return String(value).replace(/[^0-9.-]+/g, "");
};

const normalizeRatioValue = (value: any) => {
  if (value === "" || value == null) {
    return 0;
  }

  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) {
    return 0;
  }

  return numericValue > 1 ? numericValue / 100 : numericValue;
};

const formatRatioSubmitValue = (value: any) => {
  if (value === "" || value == null) {
    return 0;
  }

  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) {
    return 0;
  }

  return Number((numericValue * 100).toFixed(2));
};

const FinancialConditionShow = ({ ...props }) => {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const appId = props.appId;
  const record = props.record;
  const appStatus = props.appStatus;
  const MainSectionClassName = `Financial_mainSection_${appId}`;
  // const MainDocument = document.getElementsByClassName(MainSectionClassName)[0];
  // const MainDocument = document.querySelector(`.${MainSectionClassName}`); // Use querySelector to select the first element with the class name
  let financial_condition_data = {};
  let creditSummary = {};
  let mortgageData = {};
  let incomeData = {};

  const [totalMonthlyExpense, setTotalMonthlyExpense] = React.useState(0);
  const [totalHousingcost, setTotalHousingcost] = React.useState(0);
  const [totalMonthlyIncome, setTotalMonthlyIncome] = React.useState(0);
  const [debt_income_ratio, setDebt_income_ratio] = React.useState(0);
  const [gross_annual_income, setGross_annual_income] = React.useState(0);
  const [loanpayment_income_ratio, setLoanpayment_income_ratio] =
    React.useState(0);
  const [housingcost_income_ratio, setHousingcost_income_ratio] =
    React.useState(0);

  const [selectedIncomeTerm, setSelectedIncomeTerm] = useState(""); //only one selecte
  const [selectedExpenseArr, setSelectedExpenseArr] = useState([]); //multi select

  if (appId == null || appId == undefined) {
    return <CustomMessage message="No financial data found for this id" />;
  }
  const [financialData, setFinancialData] = useState();
  const { data, isPending, error } = useGetOne("financial", { id: appId });

  useEffect(() => {
    setFinancialData(data);
    if (data?.financial_condition_data) {
      if (data?.financial_condition_data?.debt_income_ratio) {
        setDebt_income_ratio(
          normalizeRatioValue(data?.financial_condition_data?.debt_income_ratio)
        );
      }
    }
    if (data?.financial_condition_data) {
      if (data?.financial_condition_data?.loanpayment_income_ratio) {
        setLoanpayment_income_ratio(
          normalizeRatioValue(
            data?.financial_condition_data?.loanpayment_income_ratio
          )
        );
      }
    }
    if (data?.financial_condition_data) {
      if (data?.financial_condition_data?.housingcost_income_ratio) {
        setHousingcost_income_ratio(
          normalizeRatioValue(
            data?.financial_condition_data?.housingcost_income_ratio
          )
        );
      }
    }
    if (data?.financial_condition_data) {
      if (data?.financial_condition_data?.gross_annual_income) {
        setGross_annual_income(
          data?.financial_condition_data?.gross_annual_income
        );
      }
    }

    let initIncome = 0;
    let initExpense = 0;
    let financial_condition_data = data?.financial_condition_data || {};
    if (financial_condition_data) {
      // 查找里面这些项目，如果select = 1, 则累计相加
      if (
        financial_condition_data.debt_payment_loan_applied_select == "1" &&
        financial_condition_data?.debt_payment_loan_applied
      ) {
        initExpense += parseFloat(
          financial_condition_data.debt_payment_loan_applied.replace(
            /[^0-9.-]+/g,
            ""
          )
        );
      }
      if (
        financial_condition_data.debt_revolving_select == "1" &&
        financial_condition_data?.debt_revolving
      ) {
        initExpense += parseFloat(
          financial_condition_data.debt_revolving.replace(/[^0-9.-]+/g, "")
        );
      }
      if (
        financial_condition_data.debt_installment_select == "1" &&
        financial_condition_data?.debt_installment
      ) {
        initExpense += parseFloat(
          financial_condition_data.debt_installment.replace(/[^0-9.-]+/g, "")
        );
      }
      if (
        financial_condition_data.debt_open_select == "1" &&
        financial_condition_data?.debt_open
      ) {
        initExpense += parseFloat(
          financial_condition_data.debt_open.replace(/[^0-9.-]+/g, "")
        );
      }
      if (
        financial_condition_data.debt_mortgage_select == "1" &&
        financial_condition_data?.debt_mortgage
      ) {
        initExpense += parseFloat(
          financial_condition_data.debt_mortgage.replace(/[^0-9.-]+/g, "")
        );
      }
      if (
        financial_condition_data.debt_rent_select == "1" &&
        financial_condition_data?.debt_rent
      ) {
        initExpense += parseFloat(
          financial_condition_data.debt_rent.replace(/[^0-9.-]+/g, "")
        );
      }
      if (
        financial_condition_data.debt_utility_select == "1" &&
        financial_condition_data?.debt_utility
      ) {
        initExpense += parseFloat(
          financial_condition_data.debt_utility.replace(/[^0-9.-]+/g, "")
        );
      }
      if (
        financial_condition_data.debt_other_housing_expenses_select == "1" &&
        financial_condition_data.debt_other_housing_expenses
      ) {
        initExpense += parseFloat(
          financial_condition_data.debt_other_housing_expenses.replace(
            /[^0-9.-]+/g,
            ""
          )
        );
      }
      if (
        financial_condition_data.debt_adjustments_select == "1" &&
        financial_condition_data.debt_adjustments
      ) {
        initExpense += parseFloat(
          financial_condition_data.debt_adjustments.replace(/[^0-9.-]+/g, "")
        );
      }

      // setTotalMonthlyExpense(initExpense);
      if (
        financial_condition_data.reportedIncome_select == "1" &&
        financial_condition_data.reportedIncome
      ) {
        initIncome = parseFloat(
          financial_condition_data.reportedIncome.replace(/[^0-9.-]+/g, "")
        );
      }
      if (
        financial_condition_data.verifiedIncome_select == "1" &&
        financial_condition_data.verifiedIncome
      ) {
        initIncome = parseFloat(
          financial_condition_data.verifiedIncome.replace(/[^0-9.-]+/g, "")
        );
      }
      if (
        financial_condition_data.estimatedIncome_select == "1" &&
        financial_condition_data.estimatedIncome
      ) {
        initIncome = parseFloat(
          financial_condition_data.estimatedIncome.replace(/[^0-9.-]+/g, "")
        );
      }
      if (
        financial_condition_data.observedDisposableIncome_select == "1" &&
        financial_condition_data.observedDisposableIncome
      ) {
        initIncome = parseFloat(
          financial_condition_data.observedDisposableIncome.replace(
            /[^0-9.-]+/g,
            ""
          )
        );
      }
      if (
        financial_condition_data.userDifferentIncome_select == "1" &&
        financial_condition_data.userDifferentIncome
      ) {
        initIncome = parseFloat(
          financial_condition_data.userDifferentIncome.replace(/[^0-9.-]+/g, "")
        );
      }
      // setTotalMonthlyIncome(initIncome);
    }
    if (initExpense) {
      setTotalMonthlyExpense(initExpense);
    }
    if (initIncome) {
      setTotalMonthlyIncome(initIncome);
    }

    if (financial_condition_data?.reportedIncome_select == "1") {
      setSelectedIncomeTerm("reportedIncome_select");
    } else if (financial_condition_data?.verifiedIncome_select == "1") {
      setSelectedIncomeTerm("verifiedIncome_select");
    } else if (financial_condition_data?.estimatedIncome_select == "1") {
      setSelectedIncomeTerm("estimatedIncome_select");
    } else if (
      financial_condition_data?.observedDisposableIncome_select == "1"
    ) {
      setSelectedIncomeTerm("observedDisposableIncome_select");
    } else if (financial_condition_data?.userDifferentIncome_select == "1") {
      setSelectedIncomeTerm("userDifferentIncome_select");
    }
  }, [appId, data]);

  const {
    control,
    handleSubmit,
    formState: { errors, isDirty },
    reset,
    getValues,
    setValue,
  } = useForm({
    mode: "onBlur",
    defaultValues: props?.defaultValues || {},
  });
  // React.useEffect(() => {
  //   if (data) {
  //     reset({
  //       // xxxx: data.xxxx || "NO",
  //     });
  //   }
  // }, [data, reset]);

  if (error) {
    return <Typography>Error loading Financial data</Typography>;
  }
  if (isPending) {
    return <Typography>Loading Application Financial Data</Typography>;
  }

  if (error) {
    return <Typography>Error loading financial data</Typography>;
  }

  if (!financialData || financialData === null) {
    return <Typography>Loading financial data ...</Typography>;
  }

  if (!financialData) {
    // 数据为空时展示提示信息
    return <CustomMessage message="No financial data found for this id" />;
  }

  financial_condition_data = financialData.financial_condition_data;
  creditSummary = financialData.creditSummary;
  mortgageData = financialData.mortgageData;
  incomeData = financialData.incomeData;

  const getCheckedInputTotal = (className: string) => {
    let total = 0;
    const checkboxContainers = document
      .querySelector(`.${MainSectionClassName}`)
      ?.getElementsByClassName(className);

    if (!checkboxContainers) {
      return total;
    }

    for (let i = 0; i < checkboxContainers.length; i++) {
      const checkboxInputs =
        checkboxContainers[i].getElementsByTagName("input");

      for (let j = 0; j < checkboxInputs.length; j++) {
        if (checkboxInputs[j].checked == true) {
          const amount = document.querySelector(
            `.${MainSectionClassName} input[name="${checkboxInputs[
              j
            ].name.replace("_select", "")}"]`
          )?.value;

          if (amount != "" && amount != null && amount != undefined) {
            total += parseFloat(amount.replace(/[^0-9.-]+/g, ""));
          }
        }
      }
    }

    return total;
  };

  const getCurrentLoanPayment = () => {
    if (!financialData?.monthPayment) {
      return 0;
    }

    return parseFloat(
      String(financialData.monthPayment).replace(/[^0-9.-]+/g, "")
    );
  };

  const handleAddExpnseAmount = () => {
    calMonthlyExpense();
  };
  const handleCheckExpense = () => {
    calMonthlyExpense();
  };

  const calMonthlyExpense = () => {
    const total = getCheckedInputTotal("expensecheckbox");
    setTotalMonthlyExpense(total);
    calculationRatio();
  };

  const calHousingCostExpense = () => {
    const total = getCheckedInputTotal("debtHousing");
    setTotalHousingcost(total);
    return total;
  };
  const handleAddIncomeAmount = () => {
    calMonthlyIncome();
  };
  const handleCheckIncome = (e) => {
    if (e.target.checked == true) {
      // let amount = document.getElementsByName(
      //   e.target.name.replace("_select", "")
      // )[0].value;
      let amount = document.querySelector(
        `.${MainSectionClassName} input[name="${e.target.name.replace(
          "_select",
          ""
        )}"]`
      )?.value; // Use querySelector to select the input element by name
      if (amount != "" && amount != null && amount != undefined) {
        let total = parseFloat(amount.replace(/[^0-9.-]+/g, ""));
        setTotalMonthlyIncome(total);
      } else {
        setTotalMonthlyIncome(0);
      }

      setSelectedIncomeTerm(e.target.name);
    } else {
      setTotalMonthlyIncome(0);
      setSelectedIncomeTerm("");
    }

    calculationRatio();
  };
  const calMonthlyIncome = () => {
    const total = getCheckedInputTotal("incomecheckbox");
    setTotalMonthlyIncome(total);
    return total;
  };

  const calculationRatio = () => {
    console.log("totalHousingcost", totalHousingcost);
    const debt = getCheckedInputTotal("expensecheckbox");
    const housingcost = getCheckedInputTotal("debtHousing");
    const income = getCheckedInputTotal("incomecheckbox");
    const loanpayment = getCurrentLoanPayment();
    const grossAnnualIncome = income * 12;

    setTotalMonthlyExpense(debt);
    setTotalHousingcost(housingcost);
    setTotalMonthlyIncome(income);
    setGross_annual_income(grossAnnualIncome);

    let nextDebtIncomeRatio = 0;
    let nextLoanpaymentIncomeRatio = 0;
    let nextHousingcostIncomeRatio = 0;

    if (debt && income) {
      console.log("debt / income ==> " + debt, income, debt / income);
      nextDebtIncomeRatio = debt / income;
    }
    setDebt_income_ratio(nextDebtIncomeRatio);

    if (loanpayment && income) {
      console.log(
        "loanpayment / income ==> " + loanpayment,
        income,
        loanpayment / income
      );
      nextLoanpaymentIncomeRatio = loanpayment / income;
    }
    setLoanpayment_income_ratio(nextLoanpaymentIncomeRatio);

    if (housingcost && income) {
      console.log(
        "housingcost / income ==> " + housingcost,
        income,
        housingcost / income
      );
      nextHousingcostIncomeRatio = housingcost / income;
    }
    setHousingcost_income_ratio(nextHousingcostIncomeRatio);

    return {
      debt_income_ratio: nextDebtIncomeRatio,
      loanpayment_income_ratio: nextLoanpaymentIncomeRatio,
      housingcost_income_ratio: nextHousingcostIncomeRatio,
      gross_annual_income: grossAnnualIncome,
    };
  };

  const handleSave = () => {
    const calculatedRatios = calculationRatio();
    // errorNotify("Save is not implemented yet");

    const submitData = getValues();
    const currencyFieldNames = [
      "debt_payment_loan_applied",
      "debt_revolving",
      "debt_installment",
      "debt_open",
      "debt_mortgage",
      "debt_rent",
      "debt_utility",
      "debt_other_housing_expenses",
      "debt_adjustments",
      "debt_legal",
      "debt_processing",
      "debt_appraisal",
      "debt_floodsearch",
      "debt_titlesearch",
      "debt_filing_recording",
      "reportedIncome",
      "verifiedIncome",
      "estimatedIncome",
      "observedDisposableIncome",
      "userDifferentIncome",
    ];

    currencyFieldNames.forEach((fieldName) => {
      submitData[fieldName] = sanitizeCurrencySubmitValue(
        submitData[fieldName]
      );
    });

    submitData.debt_income_ratio = formatRatioSubmitValue(
      calculatedRatios.debt_income_ratio
    );
    submitData.loanpayment_income_ratio = formatRatioSubmitValue(
      calculatedRatios.loanpayment_income_ratio
    );
    submitData.housingcost_income_ratio = formatRatioSubmitValue(
      calculatedRatios.housingcost_income_ratio
    );
    submitData.gross_annual_income = calculatedRatios.gross_annual_income;

    submitData.debt_payment_loan_applied_select =
      submitData.debt_payment_loan_applied_select ? 1 : 0;
    submitData.debt_revolving_select = submitData.debt_revolving_select ? 1 : 0;
    submitData.debt_installment_select = submitData.debt_installment_select
      ? 1
      : 0;
    submitData.debt_open_select = submitData.debt_open_select ? 1 : 0;
    submitData.debt_mortgage_select = submitData.debt_mortgage_select ? 1 : 0;
    submitData.debt_rent_select = submitData.debt_rent_select ? 1 : 0;
    submitData.debt_utility_select = submitData.debt_utility_select ? 1 : 0;
    submitData.debt_other_housing_expenses_select =
      submitData.debt_other_housing_expenses_select ? 1 : 0;
    submitData.debt_adjustments_select = submitData.debt_adjustments_select
      ? 1
      : 0;
    submitData.reportedIncome_select =
      selectedIncomeTerm == "reportedIncome_select" ? 1 : 0;
    submitData.verifiedIncome_select =
      selectedIncomeTerm == "verifiedIncome_select" ? 1 : 0;
    submitData.estimatedIncome_select =
      selectedIncomeTerm == "estimatedIncome_select" ? 1 : 0;

    submitData.observedDisposableIncome_select =
      selectedIncomeTerm == "observedDisposableIncome_select" ? 1 : 0;
    submitData.userDifferentIncome_select =
      selectedIncomeTerm == "userDifferentIncome_select" ? 1 : 0;

    // console.log("Financial Form data:", submitData);
    if (submitData) {
      const reqUrl = "saveCashflowsInfo";
      sendRequest(reqUrl, { id: appId, data: submitData }).then((res) => {
        if (res?.code == 200) {
          successNotify("Saved successfully");
        } else {
          errorNotify("Error saving " + res?.message);
        }
      });
    } else {
      errorNotify("Error saving description: No data to save");
    }
  };

  return (
    <div style={{ width: "100%" }}>
      <Grid container sx={{ width: "100%", p: 1, pr: 0 }}>
        <Grid item xs={7}>
          <HmPageHeaderTitle title={"Financial Analysis"} />
        </Grid>
        <Grid item xs={5} sx={{ pr: 0 }}>
          {(appStatus == "Initial Review" ||
            appStatus == "New" ||
            appStatus == "restart" ||
            appStatus == "Check" ||
            appStatus == "Final Review") && (
            <>
              <Button
                variant="contained"
                color="primary"
                sx={{ float: "right" }}
                onClick={handleSave}
                className="hm-button"
              >
                Calculate
              </Button>
            </>
          )}
          {appStatus != "Initial Review" &&
            appStatus != "New" &&
            appStatus != "restart" &&
            appStatus != "Check" &&
            appStatus != "Final Review" && (
              <>
                <DisabledButtonWithTip
                  tip="Calculation cannot be performed when the application is not under review."
                  label="Calculate"
                />
              </>
            )}
        </Grid>
      </Grid>

      <MainSection
        className={`Financial_mainSection_${appId} app-summary-bodysection`}
        id="mainsection-financial"
        sx={{ "& .Mui-expanded": { margin: 0, borderBottom: 0 } }}
      >
        <Accordion id="accordion-expenseSection">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Grid container>
              <Grid item xs={4} className="hm-text-title">
                Monthly Expense
              </Grid>
              <Grid item xs={2}>
                <Typography variant="h6" className="hm-text">
                  {formatCurrency(totalMonthlyExpense)}
                </Typography>
              </Grid>
            </Grid>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1} sx={{ mb: 2 }}>
              <Grid item xs={4}>
                <HeaderLabelTitle title="Expense by Category" align="left" />
              </Grid>
              <Grid item xs={2}>
                <HeaderLabelTitle title="Amount" align="left" />
              </Grid>
              <Grid item xs={2}>
                <HeaderLabelTitle title="Data Source" align="left" />
              </Grid>
              <Grid item xs={3}>
                <HeaderLabelTitle
                  title="Include in Calculating Total"
                  align="left"
                />
              </Grid>
              <Grid item xs={1}></Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
                <Typography variant="body1" sx={{ ml: 5 }}>
                  Payment on Loan Applied
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Controller
                  control={control}
                  name="debt_payment_loan_applied"
                  defaultValue={
                    financialData
                      ? formatCurrencyInputValue(financialData.monthPayment)
                      : ""
                  }
                  render={({ field }) => (
                    <CustomSmallTextField
                      {...field}
                      variant="outlined"
                      className="expenseAmountTextInput"
                      disabled
                    />
                  )}
                />
                {/* <CustomSmallTextField
                  variant="outlined"
                  name="debt_payment_loan_applied"
                  defaultValue={
                    financialData
                      ? formatCurrency(financialData.monthPayment)
                      : ""
                  }
                  className="expenseAmountTextInput"
                  disabled
                /> */}
              </Grid>
              <Grid item xs={2}></Grid>
              <Grid item xs={3} sx={{ display: "flex", alignItems: "center" }}>
                <Controller
                  control={control}
                  name="debt_payment_loan_applied_select"
                  defaultValue={
                    financial_condition_data &&
                    financial_condition_data?.debt_payment_loan_applied_select ==
                      "1"
                      ? true
                      : false
                  }
                  render={({ field }) => (
                    <Checkbox
                      {...field}
                      checked={field.value === true}
                      className="expensecheckbox"
                      onClick={handleCheckExpense}
                    />
                  )}
                />
                {/* <Checkbox
                  name="debt_payment_loan_applied_select"
                  defaultChecked={
                    financial_condition_data &&
                    financial_condition_data.debt_payment_loan_applied_select ==
                      "1"
                      ? true
                      : false
                  }
                  className="expensecheckbox"
                  onClick={handleCheckExpense}
                /> */}
              </Grid>
              <Grid item xs={1}></Grid>
            </Grid>
            <Grid container spacing={1} sx={{ mb: 2, mt: 1 }}>
              <Grid item xs={4}>
                <HeaderLabelTitle
                  title="Existing Debt Service Excluding Mortgage"
                  align="left"
                />
              </Grid>
              <Grid item xs={2}>
                {/* <HeaderLabelValue value={formatCurrency(1780)}/> */}
              </Grid>
              <Grid item xs={2}></Grid>
              <Grid item xs={2}></Grid>
              <Grid item xs={2}></Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
                <Typography variant="body1" sx={{ ml: 5 }}>
                  Revolving
                </Typography>
              </Grid>
              <Grid item xs={2}>
                {/* <CustomSmallTextField
                  variant="outlined"
                  name="debt_revolving"
                  defaultValue={
                    creditSummary &&
                    creditSummary.revolvingAmount &&
                    creditSummary.revolvingAmount.monthlyPayment
                      ? formatCurrency(
                          creditSummary.revolvingAmount.monthlyPayment
                        )
                      : ""
                  }
                  disabled
                /> */}
                <Controller
                  control={control}
                  name="debt_revolving"
                  defaultValue={
                    creditSummary &&
                    creditSummary?.revolvingAmount &&
                    creditSummary?.revolvingAmount?.monthlyPayment
                      ? formatCurrency(
                          creditSummary?.revolvingAmount.monthlyPayment
                        )
                      : ""
                  }
                  render={({ field }) => (
                    <CustomSmallTextField
                      {...field}
                      variant="outlined"
                      disabled
                    />
                  )}
                />
              </Grid>
              <Grid
                item
                xs={2}
                className="hm-text"
                sx={{ display: "grid", alignItems: "center" }}
              >
                Credit Report
              </Grid>
              <Grid item xs={2} sx={{ display: "flex", alignItems: "center" }}>
                <Controller
                  control={control}
                  name="debt_revolving_select"
                  defaultValue={
                    financial_condition_data &&
                    financial_condition_data.debt_revolving_select == "1"
                      ? true
                      : false
                  }
                  render={({ field }) => (
                    <Checkbox
                      {...field}
                      checked={field.value === true}
                      className="expensecheckbox"
                      onClick={handleCheckExpense}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
                <Typography variant="body1" sx={{ ml: 5 }}>
                  Installment Loans
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Controller
                  control={control}
                  name="debt_installment"
                  defaultValue={
                    creditSummary &&
                    creditSummary?.installmentAmount &&
                    creditSummary?.installmentAmount?.monthlyPayment
                      ? formatCurrency(
                          creditSummary?.installmentAmount?.monthlyPayment
                        )
                      : ""
                  }
                  render={({ field }) => (
                    <CustomSmallTextField
                      {...field}
                      variant="outlined"
                      disabled
                    />
                  )}
                />
              </Grid>
              <Grid
                item
                xs={2}
                className="hm-text"
                sx={{ display: "grid", alignItems: "center" }}
              >
                Credit Report
              </Grid>
              <Grid item xs={2} sx={{ display: "flex", alignItems: "center" }}>
                <Controller
                  control={control}
                  name="debt_installment_select"
                  defaultValue={
                    financial_condition_data &&
                    financial_condition_data?.debt_installment_select == "1"
                      ? true
                      : false
                  }
                  render={({ field }) => (
                    <Checkbox
                      {...field}
                      checked={field.value === true}
                      className="expensecheckbox"
                      onClick={handleCheckExpense}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
                <Typography variant="body1" sx={{ ml: 5 }}>
                  Open
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Controller
                  control={control}
                  name="debt_open"
                  defaultValue={
                    creditSummary &&
                    creditSummary?.openAmount &&
                    creditSummary?.openAmount?.monthlyPayment
                      ? formatCurrency(creditSummary?.openAmount.monthlyPayment)
                      : ""
                  }
                  render={({ field }) => (
                    <CustomSmallTextField
                      {...field}
                      variant="outlined"
                      disabled
                    />
                  )}
                />
              </Grid>
              <Grid
                item
                xs={2}
                className="hm-text"
                sx={{ display: "grid", alignItems: "center" }}
              >
                Credit Report
              </Grid>
              <Grid item xs={2} sx={{ display: "flex", alignItems: "center" }}>
                <Controller
                  control={control}
                  name="debt_open_select"
                  defaultValue={
                    financial_condition_data &&
                    financial_condition_data?.debt_open_select == "1"
                      ? true
                      : false
                  }
                  render={({ field }) => (
                    <Checkbox
                      {...field}
                      checked={field.value === true}
                      className="expensecheckbox"
                      onClick={handleCheckExpense}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>
            <Grid container spacing={1} sx={{ mb: 2 }}>
              <Grid item xs={4}>
                <HeaderLabelTitle
                  title="Monthly Housing Expense"
                  align="left"
                />
              </Grid>
              <Grid item xs={2}>
                {/* <HeaderLabelValue value={formatCurrency(1780)}/> */}
              </Grid>
              <Grid item xs={2}></Grid>
              <Grid item xs={2}></Grid>
              <Grid item xs={2}></Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
                <Typography variant="body1" sx={{ ml: 5 }}>
                  Mortgage
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Controller
                  control={control}
                  name="debt_mortgage"
                  defaultValue={
                    creditSummary &&
                    creditSummary?.mortgageAmount &&
                    creditSummary?.mortgageAmount?.monthlyPayment
                      ? formatCurrency(
                          creditSummary?.mortgageAmount.monthlyPayment
                        )
                      : ""
                  }
                  render={({ field }) => (
                    <CustomSmallTextField
                      {...field}
                      variant="outlined"
                      disabled
                    />
                  )}
                />
              </Grid>
              <Grid
                item
                xs={2}
                className="hm-text"
                sx={{ display: "grid", alignItems: "center" }}
              >
                Credit Report
              </Grid>
              <Grid item xs={2} sx={{ display: "flex", alignItems: "center" }}>
                <Controller
                  control={control}
                  name="debt_mortgage_select"
                  defaultValue={
                    financial_condition_data &&
                    financial_condition_data?.debt_mortgage_select == "1"
                      ? true
                      : false
                  }
                  render={({ field }) => (
                    <Checkbox
                      {...field}
                      checked={field.value === true}
                      className="expensecheckbox"
                      onClick={handleCheckExpense}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
                <Typography variant="body1" sx={{ ml: 5 }}>
                  Rent
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Controller
                  control={control}
                  name="debt_rent"
                  defaultValue={
                    creditSummary &&
                    creditSummary?.openAmount &&
                    creditSummary?.openAmount?.monthlyPayment
                      ? formatCurrency(creditSummary?.openAmount.monthlyPayment)
                      : ""
                  }
                  render={({ field }) => (
                    <CustomSmallTextField
                      {...field}
                      variant="outlined"
                      disabled
                    />
                  )}
                />
              </Grid>
              <Grid
                item
                xs={2}
                className="hm-text"
                sx={{ display: "grid", alignItems: "center" }}
              >
                Bank Acct
              </Grid>
              <Grid item xs={2} sx={{ display: "flex", alignItems: "center" }}>
                <Controller
                  control={control}
                  name="debt_rent_select"
                  defaultValue={
                    financial_condition_data &&
                    financial_condition_data?.debt_rent_select == "1"
                      ? true
                      : false
                  }
                  render={({ field }) => (
                    <Checkbox
                      {...field}
                      checked={field.value === true}
                      className="expensecheckbox"
                      onClick={handleCheckExpense}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
                <Typography variant="body1" sx={{ ml: 5 }}>
                  Utility
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Controller
                  control={control}
                  name="debt_utility"
                  defaultValue={
                    creditSummary &&
                    creditSummary?.openAmount &&
                    creditSummary?.openAmount?.monthlyPayment
                      ? formatCurrency(creditSummary?.openAmount.monthlyPayment)
                      : ""
                  }
                  render={({ field }) => (
                    <CustomSmallTextField
                      {...field}
                      variant="outlined"
                      disabled
                    />
                  )}
                />
              </Grid>
              <Grid
                item
                xs={2}
                className="hm-text"
                sx={{ display: "grid", alignItems: "center" }}
              >
                Bank Acct
              </Grid>
              <Grid item xs={2} sx={{ display: "flex", alignItems: "center" }}>
                <Controller
                  control={control}
                  name="debt_utility_select"
                  defaultValue={
                    financial_condition_data &&
                    financial_condition_data?.debt_utility_select == "1"
                      ? true
                      : false
                  }
                  render={({ field }) => (
                    <Checkbox
                      {...field}
                      checked={field.value === true}
                      className="expensecheckbox"
                      onClick={handleCheckExpense}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
                <Typography variant="body1" sx={{ ml: 5 }}>
                  Other Housing Expenses
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Controller
                  control={control}
                  name="debt_other_housing_expenses"
                  defaultValue={
                    financial_condition_data &&
                    financial_condition_data?.debt_other_housing_expenses
                      ? formatCurrencyInputValue(
                          financial_condition_data.debt_other_housing_expenses
                        )
                      : ""
                  }
                  render={({ field }) => (
                    <CustomSmallTextField
                      {...field}
                      variant="outlined"
                      onChange={(e) => {
                        field.onChange(e);
                        handleAddExpnseAmount();
                      }}
                      onBlur={(e) => {
                        field.onBlur();
                        field.onChange(
                          formatCurrencyInputValue(e.target.value)
                        );
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={2} sx={{ display: "grid", alignItems: "center" }}>
                Estimate
              </Grid>
              <Grid item xs={2} sx={{ display: "flex", alignItems: "center" }}>
                <Controller
                  control={control}
                  name="debt_other_housing_expenses_select"
                  defaultValue={
                    financial_condition_data &&
                    financial_condition_data?.debt_other_housing_expenses_select ==
                      "1"
                      ? true
                      : false
                  }
                  render={({ field }) => (
                    <Checkbox
                      {...field}
                      checked={field.value === true}
                      className="expensecheckbox debtHousing"
                      onClick={handleCheckExpense}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={4}>
                <HeaderLabelTitle title="Adjustments" align="left" />
              </Grid>
              <Grid item xs={2}>
                <Controller
                  control={control}
                  name="debt_adjustments"
                  defaultValue={
                    financial_condition_data &&
                    financial_condition_data?.debt_adjustments
                      ? formatCurrencyInputValue(
                          financial_condition_data.debt_adjustments
                        )
                      : ""
                  }
                  render={({ field }) => (
                    <CustomSmallTextField
                      {...field}
                      variant="outlined"
                      // className="debtHousing"
                      // onChange={handleAddExpnseAmount}
                      onChange={(e) => {
                        field.onChange(e);
                        handleAddExpnseAmount();
                      }}
                      onBlur={(e) => {
                        field.onBlur();
                        field.onChange(
                          formatCurrencyInputValue(e.target.value)
                        );
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid
                item
                xs={2}
                className="hm-text"
                sx={{ display: "grid", alignItems: "center" }}
              >
                Estimate
              </Grid>
              <Grid item xs={2} sx={{ display: "flex", alignItems: "center" }}>
                <Controller
                  control={control}
                  name="debt_adjustments_select"
                  defaultValue={
                    financial_condition_data &&
                    financial_condition_data?.debt_adjustments_select == "1"
                      ? true
                      : false
                  }
                  render={({ field }) => (
                    <Checkbox
                      {...field}
                      checked={field.value === true}
                      className="expensecheckbox"
                      onClick={handleCheckExpense}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>

            {record && record.subType == "mortgage" ? (
              <div id="mortgageSection">
                <Grid container spacing={1} sx={{ mb: 2 }}>
                  <Grid item xs={4}>
                    <HeaderLabelTitle
                      title="Mortgage Closing Fees"
                      align="left"
                    />
                  </Grid>
                  <Grid item xs={2}></Grid>
                  <Grid item xs={2}></Grid>
                  <Grid item xs={2}></Grid>
                  <Grid item xs={2}></Grid>
                </Grid>

                <Grid container spacing={1}>
                  <Grid item xs={4}>
                    <HeaderLabelTitle
                      title="Legal Fee"
                      sx={{ ml: 5 }}
                      align="left"
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <Controller
                      control={control}
                      name="debt_legal"
                      defaultValue={
                        mortgageData && mortgageData?.iLegalFee
                          ? formatCurrencyInputValue(mortgageData.iLegalFee)
                          : ""
                      }
                      render={({ field }) => (
                        <CustomSmallTextField
                          {...field}
                          variant="outlined"
                          onBlur={(e) => {
                            field.onBlur();
                            field.onChange(
                              formatCurrencyInputValue(e.target.value)
                            );
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={2}></Grid>
                  <Grid
                    item
                    xs={2}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <Controller
                      control={control}
                      name="debt_legal_select"
                      defaultValue={
                        financial_condition_data &&
                        financial_condition_data?.debt_legal_select == "1"
                          ? true
                          : false
                      }
                      render={({ field }) => (
                        <Checkbox
                          {...field}
                          checked={field.value === true}
                          className="expensecheckbox"
                          onClick={handleCheckExpense}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={2}></Grid>
                </Grid>

                <Grid container spacing={1}>
                  <Grid item xs={4}>
                    <HeaderLabelTitle
                      title="Processing Fee"
                      sx={{ ml: 5 }}
                      align="left"
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <Controller
                      control={control}
                      name="debt_processing"
                      defaultValue={
                        mortgageData && mortgageData?.iProcessingFee
                          ? formatCurrencyInputValue(
                              mortgageData.iProcessingFee
                            )
                          : ""
                      }
                      render={({ field }) => (
                        <CustomSmallTextField
                          {...field}
                          variant="outlined"
                          onBlur={(e) => {
                            field.onBlur();
                            field.onChange(
                              formatCurrencyInputValue(e.target.value)
                            );
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={2}></Grid>
                  <Grid
                    item
                    xs={2}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <Controller
                      control={control}
                      name="debt_processing_select"
                      defaultValue={
                        financial_condition_data &&
                        financial_condition_data?.debt_processing_select == "1"
                          ? true
                          : false
                      }
                      render={({ field }) => (
                        <Checkbox
                          {...field}
                          checked={field.value === true}
                          className="expensecheckbox"
                          onClick={handleCheckExpense}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={2}></Grid>
                </Grid>
                <Grid container spacing={1}>
                  <Grid item xs={4}>
                    <HeaderLabelTitle
                      title="Appraisal Fee"
                      sx={{ ml: 5 }}
                      align="left"
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <Controller
                      control={control}
                      name="debt_appraisal"
                      defaultValue={
                        mortgageData && mortgageData?.iAppraisalFee
                          ? formatCurrencyInputValue(mortgageData.iAppraisalFee)
                          : ""
                      }
                      render={({ field }) => (
                        <CustomSmallTextField
                          {...field}
                          variant="outlined"
                          onBlur={(e) => {
                            field.onBlur();
                            field.onChange(
                              formatCurrencyInputValue(e.target.value)
                            );
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={2}></Grid>
                  <Grid
                    item
                    xs={2}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <Controller
                      control={control}
                      name="debt_appraisal_select"
                      defaultValue={
                        financial_condition_data &&
                        financial_condition_data?.debt_appraisal_select == "1"
                          ? true
                          : false
                      }
                      render={({ field }) => (
                        <Checkbox
                          {...field}
                          checked={field.value === true}
                          className="expensecheckbox"
                          onClick={handleCheckExpense}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={2}></Grid>
                </Grid>
                <Grid container spacing={1}>
                  <Grid item xs={4}>
                    <HeaderLabelTitle
                      title="Flood Search Fee"
                      sx={{ ml: 5 }}
                      align="left"
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <Controller
                      control={control}
                      name="debt_floodsearch"
                      defaultValue={
                        mortgageData && mortgageData?.iFloodSearchFee
                          ? formatCurrencyInputValue(
                              mortgageData.iFloodSearchFee
                            )
                          : ""
                      }
                      render={({ field }) => (
                        <CustomSmallTextField
                          {...field}
                          variant="outlined"
                          onBlur={(e) => {
                            field.onBlur();
                            field.onChange(
                              formatCurrencyInputValue(e.target.value)
                            );
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={2}></Grid>
                  <Grid
                    item
                    xs={2}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <Controller
                      control={control}
                      name="debt_floodsearch_select"
                      defaultValue={
                        financial_condition_data &&
                        financial_condition_data?.debt_floodsearch_select == "1"
                          ? true
                          : false
                      }
                      render={({ field }) => (
                        <Checkbox
                          {...field}
                          checked={field.value === true}
                          className="expensecheckbox"
                          onClick={handleCheckExpense}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={2}></Grid>
                </Grid>
                <Grid container spacing={1}>
                  <Grid item xs={4}>
                    <HeaderLabelTitle
                      title="Title Search Fee"
                      sx={{ ml: 5 }}
                      align="left"
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <Controller
                      control={control}
                      name="debt_titlesearch"
                      defaultValue={
                        mortgageData && mortgageData?.iTitleSearchFee
                          ? formatCurrencyInputValue(
                              mortgageData.iTitleSearchFee
                            )
                          : ""
                      }
                      render={({ field }) => (
                        <CustomSmallTextField
                          {...field}
                          variant="outlined"
                          onBlur={(e) => {
                            field.onBlur();
                            field.onChange(
                              formatCurrencyInputValue(e.target.value)
                            );
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={2}></Grid>
                  <Grid
                    item
                    xs={2}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <Controller
                      control={control}
                      name="debt_titlesearch_select"
                      defaultValue={
                        financial_condition_data &&
                        financial_condition_data?.debt_titlesearch_select == "1"
                          ? true
                          : false
                      }
                      render={({ field }) => (
                        <Checkbox
                          {...field}
                          checked={field.value === true}
                          className="expensecheckbox"
                          onClick={handleCheckExpense}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={2}></Grid>
                </Grid>
                <Grid container spacing={1}>
                  <Grid item xs={4}>
                    <HeaderLabelTitle
                      title="Filing or Recording Fee"
                      sx={{ ml: 5 }}
                      align="left"
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <Controller
                      control={control}
                      name="debt_filing_recording"
                      defaultValue={
                        mortgageData && mortgageData?.iFilingRecordingFee
                          ? formatCurrencyInputValue(
                              mortgageData.iFilingRecordingFee
                            )
                          : ""
                      }
                      render={({ field }) => (
                        <CustomSmallTextField
                          {...field}
                          variant="outlined"
                          onBlur={(e) => {
                            field.onBlur();
                            field.onChange(
                              formatCurrencyInputValue(e.target.value)
                            );
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={2}></Grid>
                  <Grid
                    item
                    xs={2}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <Controller
                      control={control}
                      name="debt_filing_recording_select"
                      defaultValue={
                        financial_condition_data &&
                        financial_condition_data?.debt_filing_recording_select ==
                          "1"
                          ? true
                          : false
                      }
                      render={({ field }) => (
                        <Checkbox
                          {...field}
                          checked={field.value === true}
                          className="expensecheckbox"
                          onClick={handleCheckExpense}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={2}></Grid>
                </Grid>
              </div>
            ) : (
              <></>
            )}
          </AccordionDetails>
        </Accordion>

        <Accordion
          // defaultExpanded
          id="accordion-incomeSection"
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
          >
            <Grid container>
              <Grid item xs={4} className="hm-text-title">
                Monthly Income
              </Grid>
              <Grid item xs={2}>
                <Typography variant="h6">
                  {formatCurrency(totalMonthlyIncome)}
                </Typography>
              </Grid>
            </Grid>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1} sx={{ mb: 2 }}>
              <Grid item xs={4}>
                <HeaderLabelTitle title="Income by Source" align="left" />
              </Grid>
              <Grid item xs={2}>
                <HeaderLabelTitle title="Amount" align="left" />
              </Grid>
              <Grid item xs={2}>
                <HeaderLabelTitle title="Data Source" align="left" />
              </Grid>
              <Grid item xs={3}>
                <HeaderLabelTitle
                  title="Select to Use as Total Income"
                  align="left"
                />
              </Grid>
              <Grid item xs={1}></Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
                <Typography variant="body1" sx={{ ml: 5 }}>
                  Reported Gross Income
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Controller
                  control={control}
                  name="reportedIncome"
                  defaultValue={
                    incomeData && incomeData.reportedIncome
                      ? formatCurrency(incomeData.reportedIncome)
                      : ""
                  }
                  render={({ field }) => (
                    <CustomSmallTextField
                      {...field}
                      variant="outlined"
                      disabled
                    />
                  )}
                />
              </Grid>
              <Grid item xs={2} sx={{ display: "grid", alignItems: "center" }}>
                Applicant
              </Grid>
              <Grid item xs={3} sx={{ display: "flex", alignItems: "center" }}>
                <Controller
                  control={control}
                  name="reportedIncome_select"
                  defaultValue={
                    financial_condition_data &&
                    financial_condition_data?.reportedIncome_select == "1"
                      ? true
                      : false
                  }
                  render={({ field }) => (
                    <Checkbox
                      {...field}
                      // checked={field.value === true}
                      checked={selectedIncomeTerm === "reportedIncome_select"}
                      className="incomecheckbox"
                      onChange={(e) => {
                        handleCheckIncome(e);
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={1}></Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
                <Typography variant="body1" sx={{ ml: 5 }}>
                  Verified Gross Income
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Controller
                  control={control}
                  name="verifiedIncome"
                  defaultValue={
                    incomeData && incomeData.verifiedIncome
                      ? formatCurrency(incomeData.verifiedIncome)
                      : ""
                  }
                  render={({ field }) => (
                    <CustomSmallTextField
                      {...field}
                      variant="outlined"
                      disabled
                    />
                  )}
                />
              </Grid>
              <Grid item xs={2} sx={{ display: "grid", alignItems: "center" }}>
                Employer
              </Grid>
              <Grid item xs={2} sx={{ display: "flex", alignItems: "center" }}>
                <Controller
                  control={control}
                  name="verifiedIncome_select"
                  defaultValue={
                    financial_condition_data &&
                    financial_condition_data?.verifiedIncome_select == "1"
                      ? true
                      : false
                  }
                  render={({ field }) => (
                    <Checkbox
                      {...field}
                      checked={selectedIncomeTerm === "verifiedIncome_select"}
                      className="incomecheckbox"
                      onChange={(e) => {
                        handleCheckIncome(e);
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
                <Typography variant="body1" sx={{ ml: 5 }}>
                  Observed Gross Income @30% Income Tax
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Controller
                  control={control}
                  name="estimatedIncome"
                  defaultValue={
                    incomeData && incomeData.estimatedIncome
                      ? formatCurrency(incomeData.estimatedIncome)
                      : ""
                  }
                  render={({ field }) => (
                    <CustomSmallTextField
                      {...field}
                      variant="outlined"
                      disabled
                    />
                  )}
                />
              </Grid>
              <Grid item xs={2} sx={{ display: "grid", alignItems: "center" }}>
                Bank Acct
              </Grid>
              <Grid item xs={2} sx={{ display: "flex", alignItems: "center" }}>
                <Controller
                  control={control}
                  name="estimatedIncome_select"
                  defaultValue={
                    financial_condition_data &&
                    financial_condition_data?.estimatedIncome_select == "1"
                      ? true
                      : false
                  }
                  render={({ field }) => (
                    <Checkbox
                      {...field}
                      // checked={field.value === true}
                      checked={selectedIncomeTerm === "estimatedIncome_select"}
                      className="incomecheckbox"
                      onChange={(e) => {
                        handleCheckIncome(e);
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>

            <Grid container spacing={1}>
              <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
                <Typography variant="body1" sx={{ ml: 5 }}>
                  Observed Disposable Income
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Controller
                  control={control}
                  name="observedDisposableIncome"
                  defaultValue={
                    incomeData && incomeData.observedDisposableIncome
                      ? formatCurrency(incomeData.observedDisposableIncome)
                      : ""
                  }
                  render={({ field }) => (
                    <CustomSmallTextField
                      {...field}
                      variant="outlined"
                      disabled
                    />
                  )}
                />
              </Grid>
              <Grid item xs={2} sx={{ display: "grid", alignItems: "center" }}>
                Bank Acct
              </Grid>
              <Grid item xs={2} sx={{ display: "flex", alignItems: "center" }}>
                <Controller
                  control={control}
                  name="observedDisposableIncome_select"
                  defaultValue={
                    financial_condition_data &&
                    financial_condition_data?.observedDisposableIncome_select ==
                      "1"
                      ? true
                      : false
                  }
                  render={({ field }) => (
                    <Checkbox
                      {...field}
                      // checked={field.value === true}
                      checked={
                        selectedIncomeTerm === "observedDisposableIncome_select"
                      }
                      className="incomecheckbox"
                      onChange={(e) => {
                        handleCheckIncome(e);
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>

            <Grid container spacing={1}>
              <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
                <Typography variant="body1" sx={{ ml: 5 }}>
                  Use Different Income Amount
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Controller
                  control={control}
                  name="userDifferentIncome"
                  defaultValue={
                    financial_condition_data &&
                    financial_condition_data?.userDifferentIncome
                      ? formatCurrencyInputValue(
                          financial_condition_data?.userDifferentIncome
                        )
                      : ""
                  }
                  render={({ field }) => (
                    <CustomSmallTextField
                      {...field}
                      variant="outlined"
                      // onChange={handleAddIncomeAmount}
                      onChange={(e) => {
                        field.onChange(e);
                        handleAddIncomeAmount();
                      }}
                      onBlur={(e) => {
                        field.onBlur();
                        field.onChange(
                          formatCurrencyInputValue(e.target.value)
                        );
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={2} sx={{ display: "grid", alignItems: "center" }}>
                Estimate
              </Grid>
              <Grid item xs={2} sx={{ display: "flex", alignItems: "center" }}>
                <Controller
                  control={control}
                  name="userDifferentIncome_select"
                  defaultValue={
                    financial_condition_data &&
                    financial_condition_data?.userDifferentIncome_select == "1"
                      ? true
                      : false
                  }
                  render={({ field }) => (
                    <Checkbox
                      {...field}
                      className="incomecheckbox"
                      checked={
                        selectedIncomeTerm === "userDifferentIncome_select"
                      }
                      onChange={(e) => {
                        field.onChange(e.target.checked ? 1 : 0);
                        handleCheckIncome(e);
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion
          // defaultExpanded
          id="accordion-affordabilitySection"
          sx={{
            marginTop: "0px",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3-content"
            id="panel3-header"
            sx={{
              color: "black",
              fontWeight: "bold",
              "& .MuiAccordionSummary-content": {
                color: "black",
                fontWeight: "bold",
              },
            }}
          >
            Affordability Analysis Based on Expense and Income Selection Above
          </AccordionSummary>
          <AccordionDetails
            sx={{
              backgroundColor: "#edf4fb",
            }}
          >
            <Grid container spacing={1}>
              <Grid item xs={7}>
                <Typography
                  variant="body2"
                  color="black"
                  sx={{
                    fontSize: "0.875rem",
                    fontFamily: "Proxima Nova",
                    p: 1,
                    pl: 8,
                  }}
                >
                  Debt to Income Ratio
                </Typography>
              </Grid>
              <Grid item xs={5}>
                <HeaderTableLabelValue
                  isCalValue={true}
                  value={formatPercentage(debt_income_ratio)}
                  fontFamily="numberFontFamily"
                />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={7}>
                <Typography
                  variant="body2"
                  color="black"
                  sx={{
                    fontSize: "0.875rem",
                    fontFamily: "Proxima Nova",
                    p: 1,
                    pl: 8,
                  }}
                >
                  Loan Payment to Income Ratio
                </Typography>
              </Grid>
              <Grid item xs={5}>
                <HeaderTableLabelValue
                  isCalValue={true}
                  value={formatPercentage(loanpayment_income_ratio)}
                />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={7}>
                <Typography
                  variant="body2"
                  color="black"
                  sx={{
                    fontSize: "0.875rem",
                    fontFamily: "Proxima Nova",
                    p: 1,
                    pl: 8,
                  }}
                >
                  Housing Cost to Income Ratio
                </Typography>
              </Grid>
              <Grid item xs={5}>
                <HeaderTableLabelValue
                  isCalValue={true}
                  value={formatPercentage(housingcost_income_ratio)}
                />
              </Grid>
            </Grid>
            {record && record.subType == "mortgage" ? (
              <>
                <Grid container spacing={1}>
                  <Grid item xs={7}>
                    <Typography
                      variant="body2"
                      color="black"
                      sx={{
                        fontSize: "0.875rem",
                        fontFamily: "Proxima Nova",
                        p: 1,
                        pl: 8,
                      }}
                    >
                      Bank Account Balance
                    </Typography>
                  </Grid>
                  <Grid item xs={5}>
                    <HeaderTableLabelValue
                      isCalValue={true}
                      value={formatCurrency(
                        incomeData && incomeData?.bankAccountBalance
                          ? incomeData?.bankAccountBalance
                          : 0
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={1}>
                  <Grid item xs={7}>
                    <Typography
                      variant="body2"
                      color="black"
                      sx={{
                        fontSize: "0.875rem",
                        fontFamily: "Proxima Nova",
                        p: 1,
                        pl: 8,
                      }}
                    >
                      Cash to Close (Mortgage and Car Loan Only)
                    </Typography>
                  </Grid>
                  <Grid item xs={5}>
                    <HeaderTableLabelValue
                      isCalValue={true}
                      value={
                        data && data.cash_close
                          ? formatCurrency(data.cash_close)
                          : 0
                      }
                    />
                  </Grid>
                </Grid>
              </>
            ) : (
              <></>
            )}

            <Grid container spacing={1}>
              <Grid item xs={7}>
                <Typography
                  variant="body2"
                  color="black"
                  sx={{
                    fontSize: "0.875rem",
                    fontFamily: "Proxima Nova",
                    p: 1,
                    pl: 8,
                  }}
                >
                  Gross Annual Income
                </Typography>
              </Grid>
              <Grid item xs={5}>
                <HeaderTableLabelValue
                  isCalValue={true}
                  value={formatCurrency(gross_annual_income)}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <FinancialConditionCashFlow appId={appId} record={record} />
      </MainSection>
    </div>
  );
};

export default FinancialConditionShow;
